module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/img_169-6f7965594093c9a0251f4d0cfecac640.svg";